import React from 'react';
import ProgressMarkerWithTooltip from 'components/pure/utils/ProgressMarkerWithTooltip';

// generates something compatible with ProgressBar's 'markers' property
// given a single value
export default function generateProgressMarkers({percentage, formattedValue}) {
  return isNaN(percentage)
    ? []
    : [
        {
          renderer: () => <ProgressMarkerWithTooltip formattedValue={formattedValue} />,
          percentage,
        },
      ];
}
